<template>
  <div>
    <div style="line-height: 50px; margin-top: 50px;">
      <span v-if="showSave">添加留言</span>
      <span v-else-if="showUpdate">更新留言</span>
    </div>
    <div v-if="showUpdate">
      {{ postUserName }}
    </div>
    <div>
      <el-input
        type="textarea"
        :rows="6"
        placeholder="请输入留言"
        v-model="content"
      >
      </el-input>
    </div>
    <div v-if="showUpdate">
      创建时间: {{ new Date(postAddDate).toLocaleString() }}
    </div>
    <div style="height: 90px; line-height: 60px;  display: flex;flex-direction: row;justify-content: center;">
      <div style="width: 100px;">
        <el-button type="primary"  @click="goBackFun">取消</el-button>
      </div>
      <div v-if="showSave" style="margin-left: 50px;width: 100px;">
        <el-button type="primary" @click="addOneNewFeedback">添加</el-button>
      </div>
      <div v-else-if="showUpdate" style="margin-left: 50px;width: 100px;">
        <el-button type="primary" @click="updateOneFeedback">更新</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    componentFunction: String,
    postId: Number,
    postContent: String,
    postUserName: String,
    postAddDate: Number
  },
  mounted () {
    if (this.componentFunction === 'save') {
      this.showSave = true
    } else if (this.componentFunction === 'update') {
      this.showUpdate = true
    }
  },
  data () {
    return {
      showSave: false,
      showUpdate: false,
      content: ''
    }
  },
  methods: {
    // 添加留言
    addOneNewFeedback: async function () {
      const api = '/md/front/bbs/feedback/postManage/main/add'
      let params = {
        content: this.content
      }
      params = this.$qs.stringify(params)
      const res = await this.axios.post(api, params)
      if (res.status === 200) {
        this.$emit('flushNowPostListEvent')
        this.$emit('goBackEvent')
      }
    },
    // 更新留言
    updateOneFeedback: async function () {
      // 这里后台接口没有实现
      this.$emit('flushNowPostListEvent')
    },
    // 返回主帖列表
    goBackFun () {
      this.$emit('goBackEvent')
    }
  }
}
</script>

<style scoped></style>
